import React from 'react';
import { Input } from 'reactstrap';
import { FieldProps } from 'formik';
import { ITextArea } from './types';

type OwnProps = FieldProps<any> & ITextArea

export const TextArea: React.SFC<OwnProps> = ({ field: { ...fields }, form: { touched, errors, ...rest }, ...props }) => {
  return <Input type="textarea" {...fields} {...props} />
}